import { IMedia } from "../types";

export type MediaLinks = {
  src?: string;
  small?: string;
  medium?: string;
  thumbnail?: string;
  alt?: string;
};

export const media = (mediaObj: IMedia): MediaLinks => {
  if (!mediaObj) return {};
  const media: IMedia = mediaObj;
  const baseUrl = process.env.REACT_APP_API;
  const mediaLinks: MediaLinks = {
    src: baseUrl + media.url,
  };

  if (media?.formats) {
    const getUrl = (name: keyof MediaLinks) =>
      media.formats[name]?.url
        ? baseUrl + media.formats[name]?.url
        : mediaLinks.src;
    mediaLinks.small = getUrl("small");
    mediaLinks.medium = getUrl("medium");
    mediaLinks.thumbnail = getUrl("thumbnail");
    mediaLinks.alt = media.alternativeText ?? "";
  }
  return mediaLinks;
};
